import { render, staticRenderFns } from "./EditFieldModal.vue?vue&type=template&id=c187b5b4&lang=pug"
import script from "./EditFieldModal.vue?vue&type=script&lang=js"
export * from "./EditFieldModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports